import React, { useMemo } from 'react';
import { translate } from '../../../services/translate';
import { OccurrenceSituation } from '../../../schemas/dispatch';
import FilterRadioList, { FilterListItem } from './FilterRadioList';

interface Props {
    value: OccurrenceSituation | 'all';
    setValue: React.Dispatch<React.SetStateAction<OccurrenceSituation | 'all'>>;
}

function StatusList({ value, setValue }: Props) {
    const items: FilterListItem<OccurrenceSituation | 'all'>[] = useMemo(() => {
        const situations: (OccurrenceSituation | 'all')[] = ['pending', 'in_service', 'ongoing', 'concluded'];
        return situations.map(situation => ({
            label: translate(situation),
            value: situation
        }));
    }, []);

    return (
        <FilterRadioList
            items={items}
            value={value}
            setValue={setValue}
            clearValue='all'
        />
    );
}

export default StatusList;
